<template>
  <vs-popup
    class="down-mt4-dialog"
    :title="title"
    :active.sync="dialogShow"
  >
    <div class="down-top">
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('Trading_System')}}</div>
        <div class="line-el"></div>
        <span class="data-span">MT4</span>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('transaction_account')}}</div>
        <div class="line-el"></div>
        <span class="data-span">{{accountInfo.login}}</span>
        <i
          class="iconfont icon-copy1 pointer"
          @click="copyLoginHandle"
        ></i>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('server')}}</div>
        <div class="line-el"></div>
        <span class="data-span">{{accountInfo.serverName}}</span>
        <i
          class="iconfont icon-copy1 pointer"
          @click="copyServeHandle"
        ></i>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('Group')}}</div>
        <div class="line-el"></div>
        <span class="data-span">{{accountInfo.accType}}</span>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('User.forexLeverage')}}<el-tooltip class="" popper-class="maxwidthtooltips" :hide-after="0" effect="dark" :content="$t('User.accountCardTips1')" placement="right">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip></div>
        <div class="line-el"></div>
        <span class="data-span">1:{{accountInfo.leverage}}</span>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('User.preciousMetalLeverage')}}<el-tooltip class="" popper-class="maxwidthtooltips" :hide-after="0" effect="dark" :content="$t('User.accountCardTips2')" placement="right">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip></div>
        <div class="line-el"></div>
        <span class="data-span" v-if="accountInfo.businessType != 5">1:{{accountInfo.preciousMetalLeverage || accountInfo.preciousMetalLeverage == 0?accountInfo.preciousMetalLeverage:""}}</span>
        <span class="data-span" v-else>
          1:100
        </span>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('User.liquidationRatio')}}<el-tooltip class="" popper-class="maxwidthtooltips" :hide-after="0" effect="dark" :content="$t('User.accountCardTips3')" placement="right">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip></div>
        <div class="line-el"></div>
        <span class="data-span" v-if="accountInfo.businessType != 5">{{accountInfo.forceClosedRate || accountInfo.forceClosedRate == 0?accountInfo.forceClosedRate+'%':""}}</span>
        <span class="data-span" v-else>
          100%
        </span>
      </div>
      <div class="line-box line-flex-row">
        <div class="lin-left">{{$t('User.collateralMarginRatio')}}<el-tooltip class="" popper-class="maxwidthtooltips" :hide-after="0" effect="dark" :content="$t('User.accountCardTips4')" placement="right">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip></div>
        <div class="line-el"></div>
        <span class="data-span" v-if="accountInfo.businessType != 5">{{accountInfo.lockedMarginRate || accountInfo.lockedMarginRate == 0?accountInfo.lockedMarginRate+'%':""}}</span>
        <span class="data-span" v-else>
          50%
        </span>
      </div>





    </div>
    <div class="down-bot">
      <h4 class="bot-title">{{$t('Download_trading_software')}}</h4>
      <div class="list">
        <a
          v-for="(item,index) in clienlists"
          :key="index"
          :href="item.link"
          download
          :target="item.symbol == 'iconiOS' ? '_blank' : 'self'"
        >
<!--          需要处理图标 todo -->
          <div class="item">
            <svg
              class="svg-icon" style="font-size: 24px" aria-hidden="true" >
              <use :xlink:href="`#${item.symbol}`"></use>
            </svg>
            <div class="inner-right">
               MT4 {{item.text}}
            </div>
          </div>
        </a>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import copy from 'copy-to-clipboard';
export default {
  name: "downMt4Dialog",
  props: {
    accountInfo: {
      type: Object,
      default(){
        return {
          login: '',
        }
      }
    },
  },
  data() {
    let _this = this;
    return {
      dialogShow: false,
      title: _this.$t('trade'),
      clienlists: [
        {
          symbol: 'iconWindows',
          text: _this.$t('PC_version'),
          link: 'https://download.metatrader.com/cdn/web/maxain.group.limited/mt4/maxaingroup4setup.exe',
        },
        {
          symbol: 'iconiOS',
          text: 'IOS',
          link: 'https://download.mql5.com/cdn/mobile/mt4/ios?server=MaxainGroup-Demo,MaxainGroup-Live'
        },
        {
          symbol: 'iconAndroid',
          text: _this.$t('Android_version'),
          link: 'https://oss-hk2069.oss-cn-hongkong.aliyuncs.com/files/MetaTrader4.apk'
        },

      ]
    }
  },
  methods: {
    copyLoginHandle() {
      copy(this.accountInfo.login);
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess'),
      })
    },
    copyServeHandle() {
      copy(this.accountInfo.serverName);
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess'),
      })
    },
  },
}
</script>
<style>
.tooltipzinx{
  z-index: 999999999999999;
}
</style>
<style lang="scss" scoped>
.down-mt4-dialog {
  .down-top {
    margin-bottom: 30px;
  }
  .con-vs-tooltip{
    display: inline-block;
  }
  .data-span {
    padding-right: 10px;
  }
  .line-box {
    margin-bottom: 10px;
    font-size: 14px;
    .lin-left {
      color: #A29FAE;
    }
  }
  .bot-title {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
  }
  .item {
    border-radius: 5px;
    border: 1px solid #E6E6E6;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .svg-icon {
      font-size: 24px;
      margin-right: 20px;
    }
    .inner-right {
      font-size: 14px;
      color: #6E6B7B;
    }

  }
}
</style>
